import { isBeekeeperIntegrationEnabled } from '@lumapps/beekeeper/ducks/selectors';
import { isBeekeeperFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_TASKS, BEEKEEPER_TASKS_LITE } from '../constants';

export const isBeekeeperTasksEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_TASKS);
export const isBeekeeperTasksLiteEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_TASKS_LITE);

export const isTasksEnabled = createSelector(
    isBeekeeperIntegrationEnabled,
    isBeekeeperTasksEnabled,
    isBeekeeperTasksLiteEnabled,
    (isEnabled, isTasksEnabled, isTasksLiteEnabled) => {
        return isEnabled && (isTasksEnabled || isTasksLiteEnabled);
    },
);
